import { pick } from 'lodash-es'
import eboInstance from './ebo'
import { getItems } from './algolia'
import { isAddress } from '~/utils/validation'
import { CHAIN_ID, RARIBLE_KEY } from '~/utils/constants'

export const saveDashPrep = async (dash) => {
  try {
    const _whitelist = 'address,dash,links,itemId,intro,chainId'.split(',')
    const _data = pick(dash, _whitelist)
    if (!isAddress(_data.address)) throw new Error('Invalid Address')
    if (isNaN(_data.chainId)) throw new Error('Invalid ChainId')
    const { data } = await eboInstance({
      method: 'put',
      url: `/dashes/${dash.address}`,
      data: _data,
    })
    console.info({ savedDash: data })
    return data
  } catch (e) {
    console.error(`Failed Saving Dash Settings`, e)
    throw e
  }
}

const addAugmintableInfo = async (dashes) => {
  const details = await getItems(dashes.map(({ itemId }) => itemId).filter((x) => x))
  return dashes.map((dash) => ({
    ...dash,
    augmintable: details.find(({ objectID }) => objectID === dash.itemId),
  }))
}

export const saveDash = async (dash) => {
  try {
    if (!isAddress(dash.address)) throw new Error('Invalid Address')
    const _data = pick(dash, ['message', 'signature', 'signerAddress'])
    const { data } = await eboInstance({
      method: 'post',
      url: `/dashes/${dash.address}`,
      data: _data,
    })
    console.info({ saveDash: data })
    return addAugmintableInfo(data)
  } catch (e) {
    console.error(`Failed Saving Dash Settings`, e)
    throw e
  }
}

export const getDashes = async (address) => {
  try {
    if (!isAddress(address)) throw new Error('Invalid Address')
    const { data } = await eboInstance({
      method: 'get',
      url: `/dashes/${address}`,
      params: { chainId: CHAIN_ID },
    })

    const {ownerships} = await fetch('https://api.rarible.org/v0.1/ownerships/search', {
      method: 'POST',
      headers: {
        'X-API-KEY': RARIBLE_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        size: 50,
        filter: {
          owners: [`ETHEREUM:${address}`],
          items: data.map(({ itemId }) => itemId),
        }
      }),
    })
    .then(response => response.json())

    const ownedItemIDs = ownerships.map(i => i.itemId)
    const filteredDashes = data.filter(({ itemId }) => ownedItemIDs.includes(itemId))
    console.info({ getDashes: filteredDashes })
    return addAugmintableInfo(filteredDashes)
  } catch (e) {
    console.log(e)
    console.info(`Failed Getting Dashes for ${address}`)
  }
  return []
}
